import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { WorkflowTaskTriggerModel } from '../workflowTaskTrigger.model';
import { Injectable } from '@angular/core';
import { LovValueSummaryConverter } from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskTriggerConverter extends HttpModelConverter<WorkflowTaskTriggerModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): WorkflowTaskTriggerModel {
        return new WorkflowTaskTriggerModel();
    }

    protected enrichObject(result: WorkflowTaskTriggerModel, src: WorkflowTaskTriggerModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }


}
